import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'epod-spinner',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './epod-spinner.component.html',
  styleUrl: './epod-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EpodSpinnerComponent {
  @Input() diameter = 50;
}
